import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { RestMessage } from '@app/core/types';
import { CodeVerificationDTO } from '@app/core/types/user';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '@projects/shared/src/app/features/setting/services/settings.service';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';

@Component({
  selector: 'app-mfa-not-allow',
  templateUrl: './mfa-not-allow.component.html',
})
export class MFANotAllowComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private settingsService: SettingsService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {}

  public reset() {
    const user = this.authService.getUser();
    this.settingsService.updateTwoFactorStatus('', 2, false).subscribe({
      next: (res) => {
        console.log(res);
        localStorage.removeItem('authorizationData');
        this.authService.authData = null;
        this.router.navigate(['/login']);
      },
      error: ({ error }) => {
        console.log(error);
        this.toastService.error(`Failed!! Please try again.`);
      },
    });
  }
}
